<template>
  <header
    class="sticky inset-0 w-full h-16 md:h-20 z-40 px-5 md:px-8 flex justify-between items-center border-b border-border-color bg-white font-bold text-black-10"
    :class="isDevEnvironment === 'true' && 'mt-7'"
  >
    <div class="flex gap-3 md:gap-10 items-center">
      <span class="cursor-pointer" @click="logout" test-id="logout">
        <close-icon size="h-6 w-6" />
      </span>

      <div test-id="title">KYC Verification</div>
    </div>

    <div>
      <span class="flex items-center gap-2" v-if="isInDisputeStage">
        <dispute-icon />
        <span class="text-black-10 text-sm md:text-base font-bold"
          >Attention</span
        >
      </span>

      <span v-else>
        <span
          v-if="kycProgressPercentage >= 0"
          class="flex items-center gap-3 md:gap-5 md:pr-40"
        >
          <el-progress
            type="circle"
            :percentage="kycProgressPercentage"
            :color="$primaryColor"
            :stroke-width="mobileStroke"
            :width="mobileWidth"
          ></el-progress>
          <span>{{ kycProgressPercentage }}% Completed</span>
        </span>
      </span>
    </div>
  </header>
</template>

<script>
import kyc from '@/mixins/kyc.js'
import logout from '@/mixins/logout.js'
import breakpoints from '@/utils/breakpoints.js'

export default {
  mixins: [logout, kyc],
  data () {
    return {}
  },
  components: {
    CloseIcon: () => import('@/assets/v2/icons/CloseIcon.vue'),
    DisputeIcon: () => import('@/assets/v2/icons/AlertCircle.vue')
  },
  computed: {
    isDevEnvironment () {
      return process.env.VUE_APP_DEV_INDICATOR
    },
    mobileWidth () {
      return breakpoints.mdAndDown ? 30 : 45
    },
    mobileStroke () {
      return breakpoints.mdAndDown ? 5 : 7
    }
  }
}
</script>

<style scoped>
>>> .el-progress__text {
  display: none;
}
</style>
